import React, { useEffect, useState } from "react";

const useFetcher = ({ fetcher, params }) => {
  const [data, setData] = useState();
  const [error, setError] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [update, setUpdate] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    fetcher(params)
      .then((res) => {
        setData(res);
      })
      .catch((err) => setError(err))
      .finally(() => {
        setIsLoading(false);
      });
  }, [params, update]);

  const mutate = () => {
    setUpdate((x) => !x);
  };

  return { data, error, isLoading, mutate };
};

export default useFetcher;
